import { Pipe, PipeTransform } from '@angular/core';
import { CurrentCompanyStore } from '@macs-frontend/core/store/current-company.store';
import { DateInput, toDate } from '@macs-frontend/core/utils/date-utils';
import * as fns from 'date-fns/fp';
import { function as F, option as O } from 'fp-ts';
import { runInAction } from 'mobx';
import { defaultDateFormat } from '../../../core/utils/consts';

@Pipe({ name: 'formatDate', pure: false })
export class FormatDatePipe implements PipeTransform {
  constructor(private readonly currentCompanyStore: CurrentCompanyStore) {}

  public transform(
    value?: DateInput | null | string,
    format?: string,
  ): undefined | string {
    return F.pipe(
      value,
      O.fromNullable,
      O.fold(
        () => undefined,
        F.flow(toDate, value =>
          typeof value === 'string'
            ? value
            : F.pipe(
                value,
                fns.format(
                  format ||
                    runInAction(
                      () =>
                        this.currentCompanyStore.currentCompany?.dateFormat ||
                        defaultDateFormat,
                    ),
                ),
              ),
        ),
      ),
    );
  }
}
